module.exports = __webpack_public_path__ + "static/hiw_dog-2b035d96a92e5e9149f04467318cc66a.svg";